export default __webpack_public_path__ + "static/media/4.69bed945.svg";